import { convertArrayToCSV } from 'convert-array-to-csv';
import GET_ORG_UNITS_PERFORMANCE_REPORT from '../queries/getOrgUnitPerformanceReportQuery';
import { PERFORMANCE_METRIC_STATUSES } from '../../shared/constants/checkpoint-performance-report-metric-enums';

const fetchData = async orgUnitId => {
  if (!orgUnitId) throw new Error('No Org Unit ID selected.');

  const apollo = require('../../../apollo/configureApollo').default();
  const result = await apollo.query({
    query: GET_ORG_UNITS_PERFORMANCE_REPORT,
    variables: {
      id: orgUnitId
    },
    fetchPolicy: 'cache-first'
  });

  if (result.error) throw new Error(result.error);
  return result.data;
};

const prepareData = async queryData => {
  const performanceItems = queryData.performanceOrgUnitReport.PerformanceItems;
  if (!performanceItems.length) return [];

  const preparedData = [];

  performanceItems.map(pi => {
    const dpCount = pi.CheckpointPerformanceItemDataPoints.filter(x => x.Actual != null).length;
    if (dpCount < 2) return;

    const header = { Metric: 'Metric', Units: 'Units', Date: 'Date', Delta: 'Delta' };
    const emptyRow = {
      Metric: '',
      Units: '',
      Date: '',
      UpperLimit: '',
      LowerLimit: '',
      Actual: ''
    };

    const measurement = pi.MeasurementUnit || pi.Numerator + ' / ' + pi.Denominator;
    let prevActual = 0;

    const dataPointsWithDates = pi.CheckpointPerformanceItemDataPoints.map(dp => {
      return {
        ...dp,
        Date: dp.Checkpoints.DataCollectionDate
      };
    }).sort((a, b) => (a.Date > b.Date ? 1 : -1));

    dataPointsWithDates.map((dp, idx) => {
      const dataPoint = {};

      let delta = 0;

      if (dp.Status === PERFORMANCE_METRIC_STATUSES.Skip.Id) {
        delta = 0;
      } else if (idx === 0) {
        delta = dp.Actual;
        prevActual = dp.Actual;
      } else {
        delta = dp.Actual - prevActual;
        prevActual = dp.Actual;
      }

      dataPoint['Metric'] = pi.MeasurementName;
      dataPoint['Units'] = measurement;
      dataPoint['Date'] = dp.Date;
      dataPoint['Delta'] = delta;

      preparedData.push(dataPoint);
    });

    preparedData.push(emptyRow);
    preparedData.push(emptyRow);
    preparedData.push(header);
  });
  preparedData.pop();

  return preparedData;
};

export const getDeltaPerformanceReportCsvData = async orgUnitId => {
  const queryData = await fetchData(orgUnitId);
  const data = await prepareData(queryData);
  return convertArrayToCSV(data);
};
